module.exports = __webpack_public_path__ + "media/images/external-icon-ba2a8eb5d0f298854d00128d82a5f2cd.svg";